export default "__VITE_ASSET__BrzeIz4Z__"